<template>
  <div class="user-ranking-view">
    <el-row>
      <el-col :span="12">
        <div class="box">
          <div class="category">班级排名</div>
          <score-ranking category="1" class="mt20"></score-ranking>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="box">
          <div class="category">全校排名</div>
          <score-ranking category="0" class="mt20"></score-ranking>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import scoreRanking from '@/components/user/scoreRanking'
export default {
  name: 'userRanking',
  components: { scoreRanking },
  data () {
    return {

    }
  },
  created () {
    this.$store.dispatch('setNavigation', [{ name: '个人中心', path: '/user/center' }, { name: '排行榜' }])
  }
}
</script>

<style lang="scss">
.user-ranking-view {
  .el-row {
    min-width: 680px;
  }
  .box {
    width: 80%;
    min-width: 300px;
    padding: 0 20px;
    margin: 0 auto;
  }
  .category {
    font-size: 18px;
    font-weight: bold;
    line-height: 36px;
    border-bottom: 2px solid #ddd;
    text-align: center;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__nav {
    width: calc(100% - 2px);
  }
  .el-tabs__item {
    width: 25%;
    text-align: center;
  }
  .content {
    border: 1px solid #e4e7ed;
    border-radius: 0 0 4px 4px;
    border-top-width: 0;
    padding: 15px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/user/ranking.vue